import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import cy from "./locales/cy.json";
import pl from "./locales/pl.json";
import ur from "./locales/ur.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      cy: { translation: cy },
      pl: { translation: pl },
      ur: { translation: ur },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "cy", "pl", "ur"],
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"], lookupLocalStorage: "sh_lng" },
    interpolation: { escapeValue: false },
  });

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "cy", label: "Cymraeg" },
  { code: "pl", label: "Polski" },
  { code: "ur", label: "اردو" },
];

export default i18n;
